import { openDB } from 'idb';


// 1. Инициализация
const dbPromise = openDB('CabinetDB', 1, {
  upgrade(db) {
    db.createObjectStore('wizard'); // Создаем простое хранилище key-value
  },
});

// 2. Запись (вместо localStorage.setItem)
async function setItem(key, val) {
  const db = await dbPromise;
  return db.put('wizard', val, key);
}

// 3. Чтение (вместо localStorage.getItem)
async function getItem(key) {
  const db = await dbPromise;
  return db.get('wizard', key);
}


export {setItem, getItem};